import { defineStore } from "pinia";
import Services from '@/services/sutting/categoriesServices'
import { mapList, mapCategory } from '@/helpers/mapFuncs'
import i18n from '@/i18n'

const translateCategoryName = (name) => {
    const rawName = String(name ?? '').trim()
    if (!rawName) return rawName

    const key = `common.categories.${rawName}`
    const translated = i18n.global.t(key)
    return translated === key ? rawName : translated
}

export const useCategoriesStore = defineStore("categories", {
persist: true,
state:()=>({
    category: {},
    categories: [],
}),
getters : {
    getCategory() {
        return mapCategory(this.category)
    },
    getCategories() {
        return this.categories.map(mapCategory)
    },
    getCategoriesListRaw() {
        return this.categories.map(mapList)
    },
    getCategoriesList() {
        return this.getCategoriesListRaw.map((item) => ({
            ...item,
            label: translateCategoryName(item?.label),
        }))
    }
},
actions : {
    /** Start Sets */
    setCategory(category) {
        this.category = category
    },
    setCategories(categories) {
        this.categories = categories
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setCategory(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setCategories(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.categories.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.categories[this.categories.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.categories = this.categories.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
